import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CreateProjectComponent } from "./pages/create-project/create-project.component";
import { ProjectDetailsComponent } from "./pages/project-details/project-details.component";
import { ProjectsComponent } from "./pages/projects/projects.component";
import { ScriptWritingDashboardComponent } from "./pages/script-writing-dashboard/script-writing-dashboard.component";
import { EmotionCharactersComponent } from "./pages/emotion-characters/emotion-characters.component";
import { EmotionRepliesComponent } from "./pages/emotion-replies/emotion-replies.component";
import { ProjectTenantGuard } from "./projectTenant.guard";
import { EmotionTransferGuard } from "./emotionTransfer.guard";
import { NotFoundComponent } from "./pages/not-found/not-found.component";

const routes: Routes = [
  {
    path: "",
    component: ProjectsComponent /*, canActivate, data*/,
  },
  {
    path: "creation",
    component: CreateProjectComponent,
  },
  {
    path: "edition/:id",
    component: ProjectDetailsComponent,
    canActivate: [ProjectTenantGuard],
  },
  {
    path: "script-writing",
    component: ScriptWritingDashboardComponent,
  },
  {
    path: "emotion-characters/:id",
    component: EmotionCharactersComponent,
    canActivate: [EmotionTransferGuard, ProjectTenantGuard],
  },
  {
    path: "emotion-replies/:id",
    component: EmotionRepliesComponent,
    canActivate: [EmotionTransferGuard, ProjectTenantGuard],
  },
  {
    path: "not-found",
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TextToSpeechRoutingModule {}
